<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="700">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-TEAM-ROLE' : 'EDIT-TEAM-ROLE') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="100" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="name.hasError('required') && name.touched">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.hasError('nameExists')">
                        {{'TEAM-ROLE-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'DESCRIPTION' | translate}}
                    </span>
                    <textarea kendoTextArea rows="2" formControlName="description" maxlength="255"
                        class="w-100"></textarea>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-7">
                <label for="codeSet" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'SUBROLE-DICTIONARY' | translate }}
                    </span>
                    <kendo-combobox class="w-100" formControlName="teamType" [data]="codeSets" [textField]="'name'"
                        [valueField]="'id'" [valuePrimitive]="false">
                    </kendo-combobox>
                </label>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-7">
                <label class="k-text-uppercase dark" for="active">{{ 'TEAM-ROLE-PRIMARE-CARE-PROVIDER' | translate }}
                </label>
                <kendo-switch class="ml-2" formControlName="pcp" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
            <div class="col-5">
                <label class="k-text-uppercase dark" for="active">{{ 'ENABLED' | translate }}
                </label>
                <kendo-switch class="ml-2" formControlName="active" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                </kendo-switch>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>